module.exports = __webpack_public_path__ + "static/android-979900fd5ddcb2b84453eb10569bbf8f.svg";